import { authorizationHeader } from "../../../util/fetchUtil";
import { responseBody } from "../../../util/fetchUtil";
import { TokenManager } from "../../../util/TokenManager";

// const host = process.env.REACT_APP_API_HOST;
// const host = "https://portolaprod.azurewebsites.net/";
const host = "https://portolaprod.azurewebsites.net/";

export const loadUsers = async (limit, offset, sortQueryString) => {
  try {
    const url = `${host}/api/users/?limit=${limit || 10}&offset=${offset || 0}${
      sortQueryString || ""
    }`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: authorizationHeader(TokenManager.getToken()),
      },
    });
    const responseAsJSON = await responseBody(response);
    return responseAsJSON;
  } catch (err) {
    throw err;
  }
};
